import React, { useState } from 'react';
import { ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Field from 'redux-form/lib/Field';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import styles from './styles.css';

const numbersOnly = (value) => {
  if (!value) {
    return value;
  }
  return value.replace(/[^0-9.]/g, '');
};

const minMaxInput = ({
  // eslint-disable-next-line react/prop-types
  input, placeholder, meta, isErrorShowing,
}) => {
  const handleClearField = () => {
    input.onChange('');
  };

  return (
    <div className={styles.minMaxInput}>
      <div className={styles.minMaxInput__bling}>$</div>
      <input {...input} placeholder={placeholder} className={classNames('form-control', styles.field, (meta.error && isErrorShowing ? styles.inputError : ''))} />
      {/* matching 'x' from selector dropdown */}
      {!isEmpty(input.value) &&
        <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" onClick={handleClearField} className={styles.minMaxInput__clear}><path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path></svg>
      }
    </div>
  );
};

export const MinMaxInputs = ({ formSyncErrors }) => {
  const [isErrorShowing, setIsMinGreaterErrorShowing] = useState(false);

  return (
    <div className={styles.formColumnWide}>
      <ControlLabel>
        Amount
      </ControlLabel>
      <div className={styles.formColumnWide__searchFields}>
        <Field
          placeholder="Min"
          name="min_amount"
          type="text"
          component={minMaxInput}
          normalize={numbersOnly}
          className={classNames('form-control', styles.field, styles.inputError)}
          data-test-handle="minAmount"
          isErrorShowing={isErrorShowing}
        />
        <div className={styles.formColumnWide__spacer}>
        </div>
        <Field
          placeholder="Max"
          name="max_amount"
          type="text"
          component={minMaxInput}
          normalize={numbersOnly}
          onFocus={() => setIsMinGreaterErrorShowing(false)}
          onBlur={() => setIsMinGreaterErrorShowing(true)}
          className={classNames('form-control', styles.field)}
          data-test-handle="maxAmount"
        />
      </div>
      {formSyncErrors && !isEmpty(formSyncErrors) && isErrorShowing && <div className={styles.error}>{formSyncErrors.min_amount}</div>}
    </div>
  );
};

MinMaxInputs.propTypes = {
  formSyncErrors: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/SearchForm/MinMaxInputs.js